// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1wbuT background_white__1bJ-V"};